<!--  -->
<template>
  <div class="agreement-box">
    <div>
      <div
        class="item"
        :class="{ 'border-no': !openUser, fwb: !resigister }"
        @click="toggleAgreement('User')"
      >
        中交智运物流平台个人信息保护政策
        <img
          :src="
            !openUser
              ? require('../assets/close.png')
              : require('../assets/open.png')
          "
        />
      </div>
      <div class="content" v-if="!openUser">
        <PrivacyOwner v-if="$route.params.type === 'owner'"></PrivacyOwner>
        <PrivacyDriver v-else-if="$route.params.type === 'driver'"></PrivacyDriver>
        <PrivacyConsigner v-else-if="$route.params.type === 'consigner'"></PrivacyConsigner>
        <Privacy v-else></Privacy>
      </div>
    </div>
    <div>
      <div class="item" :class="{ fwb: !resigister }" @click="toggleAgreement('User')">
        中交智运⽤户服务协议
        <img
          :src="
            openUser
              ? require('../assets/close.png')
              : require('../assets/open.png')
          "
        />
      </div>
      <div class="content" v-if="openUser">
        <User></User>
      </div>
    </div>
  </div>
</template>

<script>
import Privacy from "./Privacy.vue";
import PrivacyOwner from "./PrivacyOwner.vue";
import PrivacyDriver from "./PrivacyDriver.vue";
import PrivacyConsigner from "./PrivacyConsigner.vue";
import User from "./User.vue";
export default {
  props: {
    resigister: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      openUser: false,
      openPrivacy: true
    };
  },

  components: { Privacy, PrivacyOwner, PrivacyDriver, PrivacyConsigner, User },

  computed: {},

  mounted() {
    console.log(this.$route.params);
  },

  methods: {
    toggleAgreement(keyword) {
      this[`open${keyword}`] = !this[`open${keyword}`];
    }
  }
};
</script>
<style lang='scss' scoped>
.agreement-box {
  .item {
    font-size: 16px;
    //

    display: flex;

    width: 100%;
    height: 53px;

    color: #222;
    border-top: 1px solid #f6f6f6;
    border-bottom: 1px solid #f6f6f6;

    justify-content: space-between;
    align-items: center;

    &.fwb {
      font-weight: 600;
    }
    &.border-no {
      border-top: none;
    }

    img {
      width: 16px;
      height: 16px;
    }
  }

  .content {
    overflow-x: hidden;
    overflow-y: auto;

    height: 350px;
    padding: 16px 0;
  }
}
</style>